/*
* @Author: 王春岩 <Bolt>
* @Date:   2016-12-21 16:31:02
* @Last Modified by:   Bolt
* @Last Modified time: 2016-12-21 19:56:52
*/

'use strict';

import './index.less';

let $ = window.$;

$('.image').each(function(index, el) {
    var $this = $(el);
    var imgSrc = $this.find('img').attr('src');
    if (imgSrc) {
        $('<div class="image-banner"></div>')
            .css({
                'background-image': `url(${imgSrc})`
            }).appendTo($(el));
    }
});



// WEBPACK FOOTER //
// ./src/modules/image/index.js